module.exports = __webpack_public_path__ + "static/fourvill-media-content-fd3dfa45fcba0cce72508b68d9be2b43.mp4";